export * from "-!../../../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./Dropzone.vue?vue&type=template&id=79dc8868&"


//////////////////
// WEBPACK FOOTER
// ./src/modules/shared/ui/public/forms/fields/Dropzone.vue?vue&type=template&id=79dc8868&
// module id = 1130
// module chunks = 0